import Player from './models/Player';

const MINIMUM_NUMBER_OF_GAMES_TO_GET_ON_LEADERBOARD = 10;

export default class Api
{
    protected toArray = (users: { [id:string]: Player }): Player[] => {
        return Object.entries(users)
            .filter(([, user]) => user.wins > 0)
            .filter(([, user]) => user.games >= MINIMUM_NUMBER_OF_GAMES_TO_GET_ON_LEADERBOARD)
            .map(([id, user]) => ({ ...user, id }))
    }

    public get = async (): Promise<Player[]> =>
    {
        const url = 'https://raw.githubusercontent.com/jpuck/tien-len-db/main/users.json';
        const response = await fetch(url);
        return this.toArray(await response.json());
    }
}
